import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import cx from "classnames";
import '../../App.css';
import {dataRegister} from "../../services/dataRegister";
import {cartRegister} from "../../services/cartRegister";
import {langRegister} from "../../services/langRegister";
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import Basket from "../../components/basket/component";
import SignupBudgetBasic from "../../components/signup-budget-basic/component";
import SignupBudgetAdvanced from "../../components/signup-budget-advanced/component";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";

const Handle = Slider.Handle;

class SignupBudget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vat: 0,
            currency: null,
            market: null,
            budget: null,
            channels: null,
            duration: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            tab: "basic",
            error: false,
            smart_spend: true
        };
        this._updateBudget = this._updateBudget.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/budget');
            ReactGA4.send({ hitType: "pageview", page: "/signup/budget" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    _updateData() {
        let stored_data = cartRegister.get();
        if (stored_data.admin_image) {
            if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
            }
        }
        if (stored_data.industry && stored_data.regions && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.budget && stored_data.plan) {
            this.setState({
                market: salesChannelRegister.get('market'),
                currency: salesChannelRegister.get('currency'),
                vat: salesChannelRegister.get('vat'),
                regions: stored_data.regions ? stored_data.regions : [],
                channels: stored_data.channels,
                budget: stored_data.budget,
                duration: stored_data.duration,
                plan: stored_data.plan,
                service_fee_percentage: stored_data.servicefee_percentage,
                service_fee_fixed: stored_data.servicefee_fixed
            })
        } else {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
        }
    }

    _updateBudget(value){
        if(value){
            this.setState({budget: value}, () => {
                cartRegister.setBudget(this.state.budget);
            });
        }
    }

    _updateSmartSpend(){
        cartRegister.setSmartSpend(this.state.smart_spend);
        //console.log(this.state.smart_spend + " SMART SPEND");
    }

    _back(){
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/filter");
    }

    _renderImpressionsTotal() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + (this.state.budget[key].budget / this.state.budget[key].cpi)
                }
            }
            return Math.ceil(impressions);
        } else {
            return ("...");
        }
    }

    _renderLeadsTotal() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.budget) {
                if (this.state.channels[key].selected) {
                    clicks = clicks + (this.state.budget[key].budget / this.state.budget[key].cpc)
                }
            }
            return Math.ceil(clicks);
        } else {
            return ("...");
        }
    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if(this.state.service_fee_fixed){
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if(this.state.service_fee_percentage){
                budget = budget + this._renderPercentageFee();
            }

            /*
            //IF VAT
            if(this.state.vat){
                budget = budget + this._renderVat();
            }
            */

            return budget;
        }
    }

    _renderPercentageFee(){
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }
            return budget * (this.state.service_fee_percentage / 100);
        }
    }

    _renderVat(){
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                if (this.state.budget[key] && this.state.channels[key].selected) {
                    budget = budget + this.state.budget[key].spend;
                }
            }

            // IF FIXED FEE
            if(this.state.service_fee_fixed){
                budget = budget + this.state.service_fee_fixed;
            }

            //IF PERCENTAGE SERVICE FEE
            if(this.state.service_fee_fixed){
                budget = budget + this._renderPercentageFee();
            }

            return budget * (this.state.vat / 100);
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-budget", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupTwo history={this.props.history} props={this.props} step={3}/>
                {
                    this.state.channels && this.state.budget && this.state.plan && this.state.currency && this.state.regions && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            <div className={Styles.title}>
                                {this._renderText("item_27")}{" "}<span className={Styles.titleBold}>{this._renderNumbers(this._renderImpressionsTotal())}{" "}</span>{this._renderText("item_28")}{" "}<span className={Styles.titleBold}>{this._renderNumbers(this._renderLeadsTotal())}</span>{" "}{this._renderText("item_29")}
                            </div>
                            <div className={Styles.containerInner}>
                                <div className={Styles.left}>

                                    <div className={Styles.tabsContainer}>
                                        <div onClick={() => this.setState({tab: "basic", smart_spend: true})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "basic",
                                                })
                                        }>
                                            {this._renderText("item_44")}
                                        </div>
                                        <div onClick={() => this.setState({tab: "advanced", smart_spend: false})} className={
                                            cx(Styles.tabsContainerItem,
                                                {
                                                    [Styles.tabsContainerItemActive]: this.state.tab === "advanced",
                                                })
                                        }>
                                            {this._renderText("item_45")}
                                        </div>
                                    </div>
                                    {
                                        this.state.tab === "basic" &&
                                        <SignupBudgetBasic updateBudget={this._updateBudget} budget={this.state.budget} channels={this.state.channels} currency={this.state.currency}/>

                                    }
                                    {
                                        this.state.tab === "advanced" &&
                                        <SignupBudgetAdvanced updateBudget={this._updateBudget} budget={this.state.budget} channels={this.state.channels} currency={this.state.currency}/>
                                    }
                                    <div onClick={() => {this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/checkout"); this._updateSmartSpend()}}
                                         className={
                                             cx(Styles.button,
                                                 {
                                                     [Styles.buttonActive]: true
                                                 })
                                         }>
                                        {this._renderText("item_14")}
                                        <span className={Styles.mobileButtonPrice}>
                                        {this._renderNumbers(this._renderPartialBudget())}{" "}{this.state.currency.toLowerCase()}
                                    </span>
                                    </div>
                                    <div onClick={() => this._back()}
                                         className={Styles.backButton}>
                                        {this._renderText("item_23")}
                                    </div>
                                </div>
                                <div className={Styles.right}>

                                    <div className={Styles.contentContainerRightInner}>
                                        <Basket updateBudget={this._updateBudget} props={this.props} regions={this.state.regions} nextView={"/signup/checkout"} serviceFeeFixed={this.state.service_fee_fixed} serviceFeePercentage={this.state.service_fee_percentage}  budget={this.state.budget} channels={this.state.channels} currency={this.state.currency} plan={this.state.plan} vat={this.state.vat} duration={this.state.duration}/>
                                        <div onClick={() => {this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/checkout"); this._updateSmartSpend()}} className={
                                            cx(Styles.contentContainerRightButton,
                                                {
                                                    [Styles.buttonActive]: true
                                                })
                                        }>
                                            {this._renderText("item_14")}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
}

export default SignupBudget;


// WEBPACK FOOTER //
// ./src/pages/signup-budget/component.js